import { render, staticRenderFns } from "./IFavorite.vue?vue&type=template&id=4387364c&scoped=true&"
import script from "./IFavorite.vue?vue&type=script&lang=js&"
export * from "./IFavorite.vue?vue&type=script&lang=js&"
import style0 from "./IFavorite.vue?vue&type=style&index=0&id=4387364c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4387364c",
  null
  
)

export default component.exports